import { getEnv } from "@/env";

export const DAPI_COOKIE_NAME =
  getEnv("NEXT_PUBLIC_DAPI_COOKIE_NAME") || "dapi_random_id";
